import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../styles/TestimonialsResultsBlock.css';

const TestimonialsResultsBlock = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerView, setItemsPerView] = useState(3);

  const testimonials = [
    { src: '/testimonios/test_1.jpeg', alt: 'Resultados de estudiante 1' },
    { src: '/testimonios/test_2.jpeg', alt: 'Resultados de estudiante 2' },
    { src: '/testimonios/test_3.jpeg', alt: 'Resultados de estudiante 3' },
    { src: '/testimonios/test_4.jpeg', alt: 'Resultados de estudiante 4' },
    { src: '/testimonios/test_5.jpeg', alt: 'Resultados de estudiante 5' },
    { src: '/testimonios/test_6.jpeg', alt: 'Resultados de estudiante 6' },
  ];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setItemsPerView(1);
      } else if (window.innerWidth <= 768) {
        setItemsPerView(2);
      } else {
        setItemsPerView(3);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <div className="testimonials-results-block">
      <div className="testimonials-carousel-wrapper">
        <button
          className="carousel-arrow carousel-arrow-prev"
          onClick={handlePrev}
          aria-label="Imagen anterior"
        >
          ‹
        </button>

        <div className="testimonials-carousel-container">
          <motion.div
            className="testimonials-carousel"
            animate={{ x: -currentIndex * (100 / itemsPerView) + '%' }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          >
            {testimonials.map((item) => (
              <motion.div
                key={item.src}
                className="testimonial-carousel-item"
                whileHover={{ scale: 1.02 }}
              >
                <img
                  src={item.src}
                  alt={item.alt}
                  loading="lazy"
                  decoding="async"
                  className="testimonial-image"
                  onClick={() => setSelectedImage(item.src)}
                  role="button"
                  tabIndex="0"
                  onKeyDown={(e) => e.key === 'Enter' && setSelectedImage(item.src)}
                />
              </motion.div>
            ))}
          </motion.div>
        </div>

        <button
          className="carousel-arrow carousel-arrow-next"
          onClick={handleNext}
          aria-label="Siguiente imagen"
        >
          ›
        </button>
      </div>

      <div className="carousel-indicators">
        {testimonials.map((_, index) => (
          <button
            key={index}
            className={`indicator-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
            aria-label={`Ir a imagen ${index + 1}`}
            aria-current={index === currentIndex}
          />
        ))}
      </div>

      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className="testimonial-modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
          >
            <motion.div
              className="testimonial-modal-content"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="testimonial-modal-close"
                onClick={() => setSelectedImage(null)}
                aria-label="Cerrar modal"
              >
                ✕
              </button>
              <img
                src={selectedImage}
                alt="Resultado ampliado"
                className="testimonial-modal-image"
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="testimonials-footnotes">
        <p className="testimonials-footnote">
          ⚠️ El trading implica riesgo. Los resultados mostrados no son típicos ni garantizados.
        </p>
        <p className="testimonials-footnote">
          Este entrenamiento es educativo y enfocado en ejecución y gestión del riesgo.
        </p>
      </div>
    </div>
  );
};

export default TestimonialsResultsBlock;
